module.exports = __webpack_public_path__ + "static/media/Gas.04aa9f76.png";